<template>
  <div class="terms">
    <header class="terms__header">
      <div class="header__content">
        <span>{{recipe.name}}</span>
        <h2>{{recipe.data.title}}</h2>
        <p>{{recipe.data.calories}} {{$t('profile.home.recipeStats')}} / {{recipe.data.time}}</p>
      </div>

      <div class="img" @click="$emit('close')">
        <img src="/media/inpulse-template-ac-new-a/profile/close.svg" alt="close">
      </div>
    </header>

    <div class="recipe__data">
      <div class="img">
        <img :src="recipe.data.image" alt="">
      </div>

      <h3>{{ $t("profile.recipes.ingredients") }}:</h3>
      <ul>
        <li v-for="ingredient in recipe.data.ingredients" :key="ingredient">{{ingredient}}</li>
      </ul>

      <h3>{{ $t("profile.recipes.methodPreparation") }}:</h3>
      <ol>
        <li v-for="step in recipe.data.steps" :key="step">{{step}}</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyModal",

  props: ["recipe"],
}
</script>
